import CustomDivider from "@/components/custom-divider/CustomDivider"
import { SvgIcon } from "@/components/icon"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import { FC } from "react"

const { Title, Paragraph } = WebsiteTypography

const SuccessNotice: FC = () => {
  return (
    <Row justify={"center"} style={{ marginTop: 24, marginBottom: 56 }}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Row justify={"center"} style={{ paddingBottom: 24 }}>
          <SvgIcon type={"circled-tick"} color={"green"} />
        </Row>

        <Title level={3} centered className={"form-section-title"}>
          <span className={"w300"}>{"Request "}</span>
          <span className={"bold"}>{"Submitted Successfully"}</span>
        </Title>

        <Row justify={"center"}>
          <Col span={18}>
            <CustomDivider color={"green"} />
          </Col>
        </Row>

        <Paragraph centered size={"lg"} style={{ paddingTop: 24 }} color={"website-secondary"}>
          {"Thank you for your interest.\nOur team will be in touch with you soon"}
        </Paragraph>
      </Col>
    </Row>
  )
}

export default SuccessNotice
